var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.$urlResolver(_vm.slug.cached_url)},nativeOn:{"click":function($event){return _vm.checkCurrentRoute($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }